/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { DarkEther } from "../DarkEther";

export class DarkEther__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<DarkEther> {
    return super.deploy(overrides || {}) as Promise<DarkEther>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): DarkEther {
    return super.attach(address) as DarkEther;
  }
  connect(signer: Signer): DarkEther__factory {
    return super.connect(signer) as DarkEther__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): DarkEther {
    return new Contract(address, _abi, signerOrProvider) as DarkEther;
  }
}

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "minter",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "entityClass",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "EntityMinted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "claimer",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "MintRewardClaimed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
    ],
    name: "TransferBatch",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "TransferSingle",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "value",
        type: "string",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "URI",
    type: "event",
  },
  {
    inputs: [],
    name: "MINIMUM_MINTS_FOR_CLAIM",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MINTS_SINCE_CLAIM_THRESHOLD",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MINT_LIMIT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "TRANSFER_TO_TREASURY_MINT_THRESHOLD",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "accounts",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
    ],
    name: "balanceOfBatch",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "claimMintReward",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "exists",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getAWethBalance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getDefaultName",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getDefaultNames",
    outputs: [
      {
        internalType: "string[]",
        name: "",
        type: "string[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "minterAddress",
        type: "address",
      },
    ],
    name: "getMintsForAddress",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "darkEthClass",
        type: "uint256",
      },
    ],
    name: "getMintsForClass",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getRewardAvailability",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "mintCounter",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "mintPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "newMintsSinceClaim",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "requestMint",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeBatchTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "transferToTreasury",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "uri",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";
